































































import { Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./equipment_sale_counter_add.vue";
import Edit from "./equipment_sale_counter_edit.vue";

@Component({
  components: {
    Add,
    Edit
  }
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  @Prop() mainEquip!: any;

  @Prop() mainEquipIdx!: number;

  mainEquipId = 0;

  dispatchType = "equipment/salecounter";

  dispatchTypeDelete = "equipment/deletesalecounter";

  deleteConfirmContent = "你确定要删除该柜门配置吗？";

  columns: any[] = [
    { title: "ID", dataIndex: "id" },
    { title: "名称", dataIndex: "name" },
    { title: "门编号", dataIndex: "number" },
    { title: "添加时间", dataIndex: "created_time" },
    { title: "更新时间", dataIndex: "updated_time" },
    { title: "打开时间", dataIndex: "open_time" },
    { title: "关闭时间", dataIndex: "close_time" },
    { title: "状态", scopedSlots: { customRender: "status" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    const obj: any = this.mainEquip[this.mainEquipIdx];
    this.mainEquipId = obj.id;
    this.loadData(
      {
        stadium_id: this.stadiumId,
        equipment_main_id: this.mainEquipId
      },
      false
    );
  }
}
